/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Component, ElementRef} from '@angular/core';
import {Focusable} from '../core/a11y/focus-key-manager';
import {CanDisable, mixinDisabled} from '../core/common-behaviors/disabled';
export class MdMenuItemBase {}
export const /** @type {?} */ _MdMenuItemMixinBase = mixinDisabled(MdMenuItemBase);
/**
 * This directive is intended to be used inside an md-menu tag.
 * It exists mostly to set the role attribute.
 */
export class MdMenuItem extends _MdMenuItemMixinBase implements Focusable, CanDisable {
/**
 * @param {?} _elementRef
 */
constructor(private _elementRef: ElementRef) {
    super();
  }
/**
 * Focuses the menu item.
 * @return {?}
 */
focus(): void {
    this._getHostElement().focus();
  }
/**
 * Used to set the `tabindex`.
 * @return {?}
 */
_getTabIndex(): string {
    return this.disabled ? '-1' : '0';
  }
/**
 * Used to set the HTML `disabled` attribute. Necessary for links to be disabled properly.
 * @return {?}
 */
_getDisabledAttr(): boolean {
    return this.disabled ? true : null;
  }
/**
 * Returns the host DOM element.
 * @return {?}
 */
_getHostElement(): HTMLElement {
    return this._elementRef.nativeElement;
  }
/**
 * Prevents the default element actions if it is disabled.
 * @param {?} event
 * @return {?}
 */
_checkDisabled(event: Event): void {
    if (this.disabled) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: '[md-menu-item], [mat-menu-item]',
  inputs: ['disabled'],
  host: {
    'role': 'menuitem',
    'class': 'mat-menu-item',
    '[attr.tabindex]': '_getTabIndex()',
    '[attr.aria-disabled]': 'disabled.toString()',
    '[attr.disabled]': '_getDisabledAttr()',
    '(click)': '_checkDisabled($event)',
  },
  templateUrl: 'menu-item.html',
  exportAs: 'mdMenuItem'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
}

function MdMenuItem_tsickle_Closure_declarations() {
/** @type {?} */
MdMenuItem.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdMenuItem.ctorParameters;
/** @type {?} */
MdMenuItem.prototype._elementRef;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
